module.exports = __webpack_public_path__ + "img/minipro_live_verify.8ff97238.png";